import { useRef } from "react";
import { cardToDeleteStore } from "features/CardToDelete";
import { openedCardStore } from "features/OpenedCard";
import { useMainViewScrollRestoration } from "features/Panel/hooks/Panel.hooks";
import { useCardHandlers } from "features/Panel/hooks/Panel.hooks";
import { useParcelCardActions } from "features/ParcelCardActions";
import { useParcelSearch } from "features/Search/model/hooks/parcelSearch.hook";
import { authStore } from "entities/Auth";
import { Card, ErrorCard, LoadCard } from "entities/Card";
import { PanelView } from "entities/PanelView";
import { parcelSearchCardStore } from "entities/ParcelSearchCard";
import { ParcelSearchCard } from "entities/ParcelSearchCard";
import { searchFilterStore } from "entities/SearchFilter";
import { mainViewId, searchShipmentLoadingText } from "shared/constants/panel.constants";
import { useAppSelector } from "shared/lib/redux";
import { useTranslation } from "shared/localization/localization";

type ParcelViewProps = {
  className?: string;
};

export const ParcelView: RFC<ParcelViewProps> = ({ className }) => {
  const { t } = useTranslation();
  const containerRef = useRef<HTMLDivElement>(null);
  const parcelSearchCards = useAppSelector(parcelSearchCardStore.selectors.searchCards);
  const isAuthenticated = useAppSelector(authStore.selectors.isAuthenticated);
  const shipmentType = useAppSelector(searchFilterStore.selectors.shipment);
  const { isParcelSearchLoading } = useParcelSearch({ isAuthenticated });
  const { openCard } = useCardHandlers({
    openedCardAction: openedCardStore.actions.setOpenedCardAction,
  });
  const { deleteParcelCardHandler } = useParcelCardActions({
    setCardToDeleteAction: (card) => ({
      type: cardToDeleteStore.actions.setCardToDeleteAction.type,
      payload: card,
    }),
    resetCardToDeleteAction: () => ({
      type: cardToDeleteStore.actions.resetCardToDeleteAction.type,
    }),
    // removeFilteredCardAction: (card) =>
    //   railSearchCardStore.actions.removeSearchCardAction({
    //     type: railSearchCardStore.actions.removeSearchCardAction.type,
    //     payload: card,
    //   }),
    // removeCardByTagAction: (card) =>
    //   railSearchCardStore.actions.removeSearchCardAction({
    //     type: railSearchCardStore.actions.removeSearchCardAction.type,
    //     payload: card,
    //   }),
    // refreshTags: () => {},
  });

  useMainViewScrollRestoration(containerRef);

  return (
    <PanelView ref={containerRef} className={className} id={mainViewId}>
      {isParcelSearchLoading && <LoadCard text={t(searchShipmentLoadingText)} />}

      {parcelSearchCards.map((card, index) => (
        <ParcelSearchCard
          key={card.reference ?? index}
          data={card}
          openCard={openCard}
          deleteCardHandler={deleteParcelCardHandler}
          shipmentType={shipmentType}
          renderCard={(props) => <Card {...props} />}
          renderErrorCard={(props) => <ErrorCard {...props} />}
        />
      ))}
    </PanelView>
  );
};
